/** Only an authenticated owner and its current persistence generation may use a journal. */
export interface ManualFootageOwner {userId:string;generation:number;}
const PREFIX='content.manual-footage.pending.v2:';
export const manualFootageStorageKey = (owner:ManualFootageOwner) =>
 `${PREFIX}${encodeURIComponent(owner.userId)}:${owner.generation}`;
/** Best-effort physical removal; the durable generation fence remains authoritative. */
export function clearManualFootageStorage(userId:string|null):{cleared:boolean;removed:number} {
 let removed=0;
 try {
  const prefix=userId ? `${PREFIX}${encodeURIComponent(userId)}:` : PREFIX;
  const keys=Array.from({length:sessionStorage.length},(_,i)=>sessionStorage.key(i)).filter((key):key is string=>!!key&&key.startsWith(prefix));
  for(const key of keys){sessionStorage.removeItem(key);if(sessionStorage.getItem(key)!==null)return {cleared:false,removed};removed++;}
  return {cleared:true,removed};
 }catch{return {cleared:false,removed};}
}
